import { AuditorDashboard } from "@/components/compliance/auditor/AuditorDashboard";

export default function AuditorPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-medium text-foreground">Auditor Dashboard</h1>
        <p className="text-muted-foreground">Review compliance items, raise findings, and request evidence</p>
      </div>
      <AuditorDashboard />
    </div>
  );
}
